(function(){
  'use strict';

  angular
    .module('app.products')
    .controller('ProductCustomController', ProductCustomController);

  function ProductCustomController(API) {
    let vm = this;

    vm.wertwert = []

    vm.$onInit = () => {
      _loadFromApi();
		}

		function _loadFromApi() {
			_loadAcamanetos();
			_loadFixacao();
		}

    function _loadAcamanetos(){
      API.get('paginas/21').then(result => vm.acabamentos = result.data[0].imagens);
      API.get('paginas/21').then(result => console.log(vm.acabamentos));
		}

		function _loadFixacao(){
			API.get('projeto').then(result => vm.fixacao = result.data);
		}
  }

})();
